import styled from "styled-components";
import { colors } from "@streeteasy/design-system";

const { BRAND, GRAY, TEXT_SECONDARY } = colors;

export const Wrapper = styled.div`
  color: ${props => (props.isHidden ? TEXT_SECONDARY : BRAND)};
  display: inline-block;
  margin-right: 18px;

  @media (max-width: 979px) {
    padding-bottom: 16px;
    margin: 0;
  }
`;

export const VerticalLine = styled.div`
  background-color: ${GRAY};
  display: inline-block;
  height: 15px;
  vertical-align: middle;
  width: 1px;

  @media (max-width: 979px) {
    display: none;
  }
`;

export const IconWrapper = styled.svg`
  fill: currentColor;
  height: 19px;
  margin: 0 8px 0 0;
  vertical-align: middle;
`;

export const TextWrapper = styled.span`
  padding-right: 16px;

  @media (max-width: 979px) {
    padding: 0;
  }
`;
